var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const MovieCameraFilled = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsxs("svg", Object.assign({ width: "10", height: "6", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [_jsx("path", { d: "M7 2.37434L8.45631 0.627756C8.54845 0.545502 8.67292 0.5 8.80328 0.5H9.50994C9.78045 0.5 10 0.69601 10 0.937522V5.06248C10 5.30399 9.78045 5.5 9.50994 5.5H8.80328C8.67292 5.5 8.54845 5.45362 8.45631 5.37224L7 3.62566", fill: fill !== null && fill !== void 0 ? fill : COLORS.PURPLE[900] }), _jsx("rect", { width: "6.5", height: "6", rx: "1.5", fill: fill !== null && fill !== void 0 ? fill : COLORS.PURPLE[900] })] })));
};
